export default "__VITE_ASSET__BLCb7U8T__"